module.exports = __webpack_public_path__ + "static/media/acacia-restorant.83072096.webp";